import { PropType } from 'vue'
import { updateValue, StateFactory, KeyGetter, defaultKeyGetter } from '@/packages/selection-controller/general/main'

/**
 * Vue props definition object.
 *
 * @category Functions
 * @export
 * @returns Props definition object.
 */
export function makeProps() {
  return {
    multiple: {
      type: Boolean,
      default: false,
    },
    modelValue: {},
    options: Array,
    keyGetter: {
      type: Function as unknown as PropType<KeyGetter>,
      default: defaultKeyGetter,
    },
    updateHandler: {
      type: Function as PropType<typeof updateValue>,
      default: updateValue,
    },
    states: {
      type: Object as PropType<StateFactory>,
      default: () => ({}),
    },
  }
}
